var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 22,
    viewBox: "0 0 49 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38299_13382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1799 11.1539V16.524H21.3799V3.24316H26.0599C27.1999 3.24316 28.2799 3.64736 29.1199 4.39802C29.9599 5.09093 30.3799 6.1303 30.3799 7.22742C30.3799 8.32453 29.9599 9.30616 29.1199 10.0568C28.2799 10.8075 27.2599 11.2117 26.0599 11.2117L23.1799 11.1539ZM23.1799 4.85996V9.47939H26.1799C26.8399 9.47939 27.4999 9.24841 27.9199 8.78647C28.8799 7.92033 28.8799 6.47676 27.9799 5.61062L27.9199 5.55288C27.4399 5.09093 26.8399 4.80222 26.1799 4.85996H23.1799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5199 7.16968C35.8399 7.16968 36.8599 7.51613 37.6399 8.20905C38.4199 8.90196 38.7799 9.82585 38.7799 10.9807V16.524H37.0999V15.2537H37.0399C36.3199 16.293 35.2999 16.8127 34.0999 16.8127C33.0799 16.8127 32.1799 16.524 31.4599 15.9466C30.7999 15.3692 30.3799 14.5608 30.3799 13.6946C30.3799 12.7707 30.7399 12.0201 31.4599 11.4426C32.1799 10.8652 33.1999 10.6342 34.3999 10.6342C35.4799 10.6342 36.3199 10.8075 36.9799 11.2117V10.8075C36.9799 10.23 36.7399 9.65262 36.2599 9.30616C35.7799 8.90196 35.1799 8.67099 34.5199 8.67099C33.4999 8.67099 32.7199 9.07519 32.1799 9.88359L30.6199 8.9597C31.5799 7.74711 32.8399 7.16968 34.5199 7.16968ZM32.2399 13.7524C32.2399 14.2143 32.4799 14.6185 32.8399 14.8495C33.2599 15.1382 33.7399 15.3114 34.2199 15.3114C34.9399 15.3114 35.6599 15.0227 36.1999 14.503C36.7999 13.9833 37.0999 13.3482 37.0999 12.6552C36.5599 12.251 35.7799 12.0201 34.7599 12.0201C34.0399 12.0201 33.4399 12.1933 32.9599 12.5398C32.4799 12.8285 32.2399 13.2327 32.2399 13.7524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5001 7.4585L42.5601 20.5661H40.7601L42.9801 16.0044L39.0801 7.51624H41.0001L43.8201 14.0412H43.8801L46.6401 7.51624H48.5001V7.4585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0399 9.999C16.0399 9.47931 15.9799 8.95963 15.9199 8.43994H8.41992V11.3848H12.6799C12.4999 12.3087 11.9599 13.1749 11.1199 13.6945V15.6H13.6999C15.1999 14.272 16.0399 12.3087 16.0399 9.999Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42082 17.4478C10.5808 17.4478 12.3808 16.7549 13.7008 15.6L11.1208 13.6945C10.4008 14.1564 9.50082 14.4451 8.42082 14.4451C6.38082 14.4451 4.58082 13.1171 3.98082 11.2693H1.34082V13.2325C2.72082 15.831 5.42082 17.4478 8.42082 17.4478Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97937 11.2692C3.61937 10.3453 3.61937 9.30597 3.97937 8.32434V6.36108H1.33937C0.199375 8.49757 0.199375 11.0382 1.33937 13.2325L3.97937 11.2692Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42039 5.20641C9.56039 5.20641 10.6404 5.61061 11.4804 6.36127L13.7604 4.16704C12.3204 2.8967 10.4004 2.14605 8.48039 2.20379C5.48039 2.20379 2.72039 3.82059 1.40039 6.41901L4.04039 8.38227C4.58039 6.5345 6.38039 5.20641 8.42039 5.20641Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38299_13382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayIcon);
export default __webpack_public_path__ + "static/media/google-pay-icon.e30a358e60a1bf513125b425c9021df8.svg";
export { ForwardRef as ReactComponent };